export default __webpack_public_path__ + "static/media/Manita.3dc0fa6b.jpg";